/** Grain colours, light -> deep. blue: a cool blue sand (reading is blue in the lab's colour code, ruling 10/26 22:02);
 *  sand: the earlier warm gold. Pure data. */
export const PALETTES = {
  blue: [
    [0.56, 0.72, 0.98],
    [0.33, 0.5, 0.88],
    [0.17, 0.28, 0.64],
  ],
  sand: [
    [0.8, 0.6, 0.34],
    [0.68, 0.46, 0.22],
    [0.54, 0.34, 0.15],
  ],
}
